import { Button } from "@mui/material";
import { InputBox } from "@components/index";
import { useChangePasswordData } from "./changePasswordData";
import Icon from "../../components/Icon";
import "./index.scss";

const ChangePassword = () => {
  const {
    formData,
    // errors,
    showPasswords,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    togglePasswordVisibility,
    getFieldError,
    hasFieldError,
    isFormValid,
  } = useChangePasswordData();

  return (
    <div className="change-password-page">
      <div className="change-password-container">
        {/* Header */}
        <div className="change-password-header">
          <h1 className="change-password-title">Change Password</h1>
          <p className="change-password-subtitle">
            Update your account password for better security
          </p>
        </div>

        <div className="change-password-form-container">
          <form className="change-password-form" onSubmit={handleSubmit}>
            {/* Current Password - Commented out for now */}
            <div className="form-group">
              <InputBox
                label="Current Password"
                type={showPasswords.currentPassword ? "text" : "password"}
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter your current password"
                error={hasFieldError("currentPassword")}
                helperText={getFieldError("currentPassword")}
                required
                fullWidth
                className="password-input"
                endAdornment={
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("currentPassword")}
                    className="password-toggle-button"
                    aria-label={
                      showPasswords.currentPassword
                        ? "Hide password"
                        : "Show password"
                    }
                    tabIndex={-1}
                  >
                    <Icon
                      iconName={
                        showPasswords.currentPassword ? "eyeClose" : "eyeOpen"
                      }
                      width={20}
                      height={20}
                      className="eye-button"
                    />
                  </button>
                }
              />
            </div>

            {/* New Password */}
            <div className="form-group">
              <InputBox
                label="New Password"
                type={showPasswords.newPassword ? "text" : "password"}
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter your new password"
                error={hasFieldError("newPassword")}
                helperText={getFieldError("newPassword")}
                required
                fullWidth
                className="password-input"
                endAdornment={
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("newPassword")}
                    className="password-toggle-button"
                    aria-label={
                      showPasswords.newPassword
                        ? "Hide password"
                        : "Show password"
                    }
                    tabIndex={-1}
                  >
                    <Icon
                      iconName={
                        showPasswords.newPassword ? "eyeClose" : "eyeOpen"
                      }
                      width={20}
                      height={20}
                      className="eye-button"
                    />
                  </button>
                }
              />
            </div>

            {/* Confirm New Password */}
            <div className="form-group">
              <InputBox
                label="Confirm New Password"
                type={showPasswords.confirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Confirm your new password"
                error={hasFieldError("confirmPassword")}
                helperText={getFieldError("confirmPassword")}
                required
                fullWidth
                className="password-input"
                endAdornment={
                  <button
                    type="button"
                    onClick={() => togglePasswordVisibility("confirmPassword")}
                    className="password-toggle-button"
                    aria-label={
                      showPasswords.confirmPassword
                        ? "Hide password"
                        : "Show password"
                    }
                    tabIndex={-1}
                  >
                    <Icon
                      iconName={
                        showPasswords.confirmPassword ? "eyeClose" : "eyeOpen"
                      }
                      width={20}
                      height={20}
                      className="eye-button"
                    />
                  </button>
                }
              />
            </div>

            {/* Password Requirements - Simplified */}
            <div className="password-requirements">
              <h4>Password Requirements:</h4>
              <ul>
                <li
                  className={
                    formData.newPassword.length >= 5 ? "requirement-met" : ""
                  }
                >
                  At least 5 characters long
                </li>
                {/* Commented out complex requirements for now */}
                <li
                  className={
                    /[A-Z]/.test(formData.newPassword) ? "requirement-met" : ""
                  }
                >
                  Contains uppercase letter
                </li>
                <li
                  className={
                    /[a-z]/.test(formData.newPassword) ? "requirement-met" : ""
                  }
                >
                  Contains lowercase letter
                </li>
                <li
                  className={
                    /\d/.test(formData.newPassword) ? "requirement-met" : ""
                  }
                >
                  Contains at least one number
                </li>
                <li
                  className={
                    /[!@#$%^&*(),.?":{}|<>]/.test(formData.newPassword)
                      ? "requirement-met"
                      : ""
                  }
                >
                  Contains special character
                </li>
              </ul>
            </div>

            {/* Form Actions */}
            <div className="form-actions">
              <Button
                type="button"
                variant="outlined"
                size="large"
                className="cancel-button"
                onClick={() => window.history.back()}
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                size="large"
                className={`submit-button ${isSubmitting ? "loading" : ""}`}
                disabled={isSubmitting || !isFormValid}
              >
                {isSubmitting ? "Updating..." : "Update Password"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
